
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"data-name":"타원 169","cx":"15","cy":"15","r":"15","fill":"#fff"}}),_c('path',{attrs:{"data-name":"Icon feather-heart","d":"M21.814 9.238a4.223 4.223 0 00-5.974 0l-.814.814-.814-.814a4.225 4.225 0 10-5.975 5.974l.814.814 5.974 5.977 5.974-5.974.814-.814a4.223 4.223 0 000-5.974z","fill":"#f36628","stroke":"#f36628","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}})])
          )
        }
      }
    